import { markRenderArtifact } from '../../shared/render-artifact.js';

export function nextSortDir(currentKey, currentDir, clickedKey) {
    return currentKey === clickedKey && currentDir === 'asc' ? 'desc' : 'asc';
}

export function updateSortHeaders(gridEl, key, dir) {
    const ascending = dir === 'asc';
    gridEl.querySelectorAll('.sortable').forEach(th => {
        const sorted = th.dataset.sort === key;
        th.classList.toggle('sorting_asc', sorted && ascending);
        th.classList.toggle('sorting_desc', sorted && !ascending);
        const icon = th.querySelector('.sort-icon');
        if (!icon) return;
        icon.classList.toggle('fa-sort', !sorted);
        icon.classList.toggle('fa-sort-up', sorted && ascending);
        icon.classList.toggle('fa-sort-down', sorted && !ascending);
    });
}

const PAGINATION_ICONS = [
    'fa-solid fa-angles-left',
    'fa-solid fa-arrow-left',
    'fa-solid fa-arrow-right',
    'fa-solid fa-angles-right',
];

const pageSelectByContainer = new WeakMap();

function paginationButtonLabel(pageNum, current, totalPages) {
    if (pageNum === 1) return 'First page';
    if (pageNum === totalPages) return 'Last page';
    return pageNum < current ? 'Previous page' : 'Next page';
}

function createPaginationButtons(container) {
    const buttons = PAGINATION_ICONS.map((iconClasses) => {
        const btn = markRenderArtifact(document.createElement('button'));
        btn.type = 'button';
        const icon = document.createElement('i');
        icon.className = iconClasses;
        btn.appendChild(icon);
        btn.addEventListener('click', () => {
            if (btn.classList.contains('disabled')) return;
            pageSelectByContainer.get(container)(Number(btn.dataset.page));
        });
        return btn;
    });
    container.replaceChildren(...buttons);
    return buttons;
}

function paginationButtons(container) {
    const existing = container.querySelectorAll(':scope > .data-grid-paginate-btn');
    return existing.length === PAGINATION_ICONS.length ? Array.from(existing) : createPaginationButtons(container);
}

export function renderPagination(container, current, totalPages, onPageSelect) {
    if (!container) return;
    if (totalPages <= 1) {
        container.replaceChildren();
        return;
    }
    pageSelectByContainer.set(container, onPageSelect);
    const targets = [1, current - 1, current + 1, totalPages];
    const disabledStates = [current <= 1, current <= 1, current >= totalPages, current >= totalPages];
    paginationButtons(container).forEach((btn, i) => {
        const pageNum = targets[i];
        btn.className = 'data-grid-paginate-btn' + (pageNum === current ? ' active' : '') + (disabledStates[i] ? ' disabled' : '');
        btn.dataset.page = String(pageNum);
        btn.setAttribute('aria-label', paginationButtonLabel(pageNum, current, totalPages));
    });
}
